<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>用户余额查询</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div>dome请见UnifiedPayTrans，<router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS1309</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td>商户入驻成功后，生成的行方全局唯一的商户编号</td></tr>
          <tr><td>账户编号</td><td>acctCd</td><td>String(32)</td><td>否</td><td>用户账户编号 ACCT100000901</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>余额</td><td>balance</td><td>String（32）</td><td>是</td><td>单位元</td></tr>
          <tr><td>待结算余额</td><td>freezeFee</td><td>String（32）</td><td>是</td><td>单位元</td></tr>
          <tr><td>账户编号</td><td>acctCd</td><td>String（32）</td><td>是</td><td>提现用户账户编号 ACCT100000901</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'QueryBalance',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [{'url': '/interface/acct/userreg', 'name': '用户注册'},
        {'url': '/interface/acct/userbindcard', 'name': '用户绑卡'},
        {'url': '/interface/acct/splitacct', 'name': '分账'},
        {'url': '/interface/acct/transfer', 'name': '转账'},
        {'url': '/interface/acct/cash', 'name': '提现'},
        {'url': '/interface/acct/querybalance', 'name': '用户余额查询'},
        {'url': '/interface/acct/queryorder', 'name': '交易查询'},
        {'url': '/interface/acct/asynnotice', 'name': '异步回调'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/acct/querybalance.vue